import React, { Component } from "react";
import PropTypes from "prop-types";
import fordStyles from "./SubNav.module.scss";
import lincolnStyles from "./SubNav-Lincoln.module.scss";
import Tabs from "@mui/material/Tabs";
import subNavFordStyles from "./subNavStyles";
import subNavLincolnStyles from "./subNavStyles-Lincoln";
import Tab from "@mui/material/Tab";
import { withTranslation } from "react-i18next";
import { MenuItem, Popover } from "@mui/material";
import KeyboardArrowDown from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUp from "@mui/icons-material/KeyboardArrowUp";
import { withRouter } from "react-router-dom";
import CapitalizeFirstWord from "../../utils/CapitalizeFirstWord";

class SubNavTabs extends Component {
  constructor(props) {
    super(props);
    this.state = {
      anchorEl: null,
    };
  }

  handlePopOverClick = (event) => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handlePopOverClose = () => {
    this.setState({ anchorEl: null });
  };

  handleMenuItemClick = (event, value) => {
    this.handlePopOverClose();
    this.props.action(event, value);
  };

  getStyles = () => {
    return this.props.isFordBrand ? fordStyles : lincolnStyles;
  };

  getSubNavStyles = () => {
    return this.props.isFordBrand ? subNavFordStyles : subNavLincolnStyles;
  };

  getTabStyle = (item, index) => {
    const subNavStyles = this.getSubNavStyles();

    if (item.hide) {
      return subNavStyles.hide;
    }

    if (item.disabledStyle || !item.enabled) {
      return subNavStyles.disabledTab;
    }

    if (this.props.selectedTab === index) {
      return subNavStyles.highlighted;
    }

    return subNavStyles.tab;
  };

  getMenuItemStyle = (item, index) => {
    const subNavStyles = this.getSubNavStyles();

    if (item.hide) {
      return subNavStyles.hide;
    }

    if (this.props.selectedTab === index) {
      return subNavStyles.highlightedMenuItem;
    }

    return subNavStyles.menuItem;
  };

  getTabsValue = () => {
    const { selectedTab, visibleTabsCount } = this.props;

    if (selectedTab < visibleTabsCount) {
      return selectedTab;
    }

    return false;
  };

  getTabsVariant = () => {
    return this.props.visibleTabsCount === 100 ? "scrollable" : "standard";
  };

  getMoreTabStyle = () => {
    const subNavStyles = this.getSubNavStyles();

    if (this.props.selectedTab >= this.props.visibleTabsCount) {
      return subNavStyles.highlighted;
    }

    return subNavStyles.tab;
  };

  renderArrow = (arrowStyle) => {
    if (this.state.anchorEl === null) {
      return <KeyboardArrowDown style={arrowStyle} />;
    }

    return <KeyboardArrowUp style={arrowStyle} />;
  };

  renderTab = (item, index) => {
    if (index >= this.props.visibleTabsCount) {
      return null;
    }

    return (
      <Tab
        sx={{ minWidth: "20px", fontSize: 14, px: 4 }}
        style={this.getTabStyle(item, index)}
        id={`tab${item.id}`}
        key={item.id}
        value={index}
        data-testid={`tab${item.id}`}
        label={CapitalizeFirstWord(item.menuName)}
        disabled={!item.enabled}
      />
    );
  };

  renderMenuItem = (item, index) => {
    if (index < this.props.visibleTabsCount) {
      return null;
    }

    return (
      <MenuItem
        onClick={(event) => this.handleMenuItemClick(event, index)}
        value={index}
        key={item.id}
        data-testid={`tab${item.id}`}
        id={`tab${item.id}`}
        style={this.getMenuItemStyle(item, index)}
        disabled={!item.enabled}
      >
        {item.menuName}
      </MenuItem>
    );
  };

  renderMoreTab = () => {
    const styles = this.getStyles();
    const arrow = {
      position: "absolute",
      paddingTop: "1px",
      display: "inline-block",
    };

    return (
      <button
        type="button"
        data-testid="moreTab"
        onClick={this.handlePopOverClick}
        onMouseEnter={this.handlePopOverClick}
        className={styles.moreTab}
        style={this.getMoreTabStyle()}
      >
        <span>
          {this.props.t("SubNav.more")}
          {this.renderArrow(arrow)}
        </span>
      </button>
    );
  };

  renderPopover = () => {
    const open = Boolean(this.state.anchorEl);

    return (
      <Popover
        open={open}
        anchorEl={this.state.anchorEl}
        onClose={this.handlePopOverClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        id="subNavMenuDropdown"
        PaperProps={{ square: true }}
      >
        {this.props.tabs.map(this.renderMenuItem)}
      </Popover>
    );
  };

  renderTabs = () => {
    const styles = this.getStyles();
    const subNavStyles = this.getSubNavStyles();

    return (
      <Tabs
        id="tabs"
        data-testid="tabs"
        value={this.getTabsValue()}
        onChange={this.props.action}
        TabIndicatorProps={{ style: subNavStyles.highlighted }}
        textColor="primary"
        variant={this.getTabsVariant()}
        scrollButtons={false}
        classes={{
          flexContainer: styles.flexContainer,
          scrollable: styles.scrollable,
        }}
      >
        {this.props.tabs.map(this.renderTab)}
      </Tabs>
    );
  };

  renderMoreSection = () => {
    if (this.props.tabs.length <= this.props.visibleTabsCount) {
      return null;
    }

    return (
      <>
        {this.renderMoreTab()}
        {this.renderPopover()}
      </>
    );
  };

  render() {
    const styles = this.getStyles();

    if (!this.props.tabs.length) {
      return <div className={styles.root} />;
    }

    return (
      <div className={styles.root}>
        {this.renderTabs()}
        {this.renderMoreSection()}
      </div>
    );
  }
}

const tabShape = PropTypes.shape({
  disabledStyle: PropTypes.bool,
  enabled: PropTypes.bool,
  hide: PropTypes.bool,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  menuName: PropTypes.string.isRequired,
});

SubNavTabs.propTypes = {
  action: PropTypes.func.isRequired,
  isFordBrand: PropTypes.bool,
  selectedTab: PropTypes.number,
  t: PropTypes.func.isRequired,
  tabs: PropTypes.arrayOf(tabShape),
  visibleTabsCount: PropTypes.number,
};

SubNavTabs.defaultProps = {
  isFordBrand: true,
  selectedTab: 0,
  tabs: [],
  visibleTabsCount: 100,
};

export default withRouter(withTranslation("emp")(SubNavTabs));
